import { ReactNode } from 'react';
import { badgePill } from './styles';

// Consistent white-block chrome (title + inline subtitle + optional header pill)
// for each dashboard section.
interface SectionCardProps {
    title: string;
    // Grey count shown inline next to the title, e.g. "8 industries".
    subtitle?: string;
    // Right-aligned pill badge, e.g. "5,431 alumni".
    badge?: ReactNode;
    children: ReactNode;
    // Spacing override; defaults to a bottom margin.
    spacingClass?: string;
}

const SectionCard = ({ title, subtitle, badge, children, spacingClass = 'mb-4' }: SectionCardProps) => (
    <div className={`white-block p-3 p-md-4 ${spacingClass}`}>
        <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
            <div className="d-flex align-items-baseline">
                <h3 className="font-22 font-600 mb-0">{title}</h3>
                {subtitle && <span className="font-13 ms-2" style={{ color: '#8a97a5' }}>{subtitle}</span>}
            </div>
            {badge !== undefined && badge !== null && <span style={badgePill}>{badge}</span>}
        </div>
        {children}
    </div>
);

export default SectionCard;
